(function () {
  'use strict';
  angular.module('vcexam')
    .component('dicomconfig', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="panel panel-info">
        <div class="panel-heading">
          <h3>DICOM Modalities</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>AE Title DICOM fähiger Geräte</label>
            <listeditor list="vm.dicomaetitle.dicomaetitle" parentsave="vm.childsavepat(list)"></listeditor>
          </div>
        </div>
 
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService',
        function ($log, Config, Rlog, vertxEventBusService) {
          let vm = this;
          vm.childsavepat = childsavepat;

          vm.$onInit = function () {

            Config.$find('dicomaetitle').$then(function (dicomaetitle) {
              vm.dicomaetitle = dicomaetitle;
              // intialize if still empty
              if (angular.isUndefined(vm.dicomaetitle.dicomaetitle)) {
                vm.dicomaetitle._id = 'dicomaetitle';
                vm.dicomaetitle.dicomaetitle = [];
              }
            });
          };




          function childsavepat(list) {
            vm.dicomaetitle.dicomaetitle = list;
            savepat();
          }
          

          function savepat() {
            if (vm.dicomaetitle.$hasPendingActions()) {
              vm.dicomaetitle.$cancel();
            }
            vm.dicomaetitle.$save();
          }


          vertxEventBusService.on('config.update', function (message) {
            // $log.debug('debug: config update received: ', message);
            let messages = message.split(':');

            if (messages[0] === 'dicomaetitle') {
              vm.dicomaetitle.$refresh().$then(function () {
                $log.debug('debug: config refresh dicomaetitle');
              }, function (error) {
                $log.debug('debug: config refresh dicomaetitle failed: ', error);
              });
            }
          });


        }] // controller
    }); // component

// klammerfriedhof
}());
